"use strict";

import Feature from "ol/Feature";
import Geometry from 'ol/geom/Geometry';

/**
 * @classdesc
 * Feature-Implementierung auf Basis der Openlayers Kartenbibliothek.
 *
 * @class
 * @extends gc.gis.feature.GCFeature
 * @memberof gc.gis.feature
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {ol.Feature} feature
 */
gc.gis.feature.OLFeature = function(feature)
{
	// FIXME: eigentlich sollten keine Instanzen ohne Angabe eines zu wrappenden Features gezogen werden
	if (feature)
	{
		gc.gis.assert.isInstance(feature, Feature);
	}

    gc.gis.feature.GCFeature.call(this, feature);

    /**
     * @protected
     * @type ol.Feature
     */
    this._feature = feature;    // passiert zwar in Parent-Konstruktor aber zwecks Typehint sinnvoll

	/**
     * @protected
	 * @type {gc.gis.geom.OLGeometry|null}
	 * @private
	 */
	this._gc_geometry = undefined;

	if (this._feature && this._feature.getGeometry())
    {
    	const geometryFactory = new gc.gis.geom.OLGeometryFactory();
        this.setGeometry(geometryFactory.createGeometry(this._feature.getGeometry()));
    }
};
gc.gis.feature.OLFeature.prototype = Object.create(gc.gis.feature.GCFeature.prototype);

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.setID = function (id)
{
    this._feature.setId(id);
    return this;
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.getID = function ()
{
    return this._feature.getId();
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.setGeometry = function (geometry)
{
    if (geometry)
    {
	    // gc.gis.geom.OLGeometryCollection ist keine Ableitung von gc.gis.geom.OLGeometry sondern ein Mixin.
    	if (!geometry instanceof gc.gis.geom.OLGeometry && !geometry instanceof gc.gis.geom.OLGeometryCollection)
	    {
		    gc.gis.assert.isInstance(geometry, gc.gis.geom.OLGeometry);
	    }
	    gc.gis.assert.isInstance(geometry.getImpl(), Geometry);

	    this._gc_geometry = geometry;
	    this._feature.setGeometry(geometry.getImpl());
    }
    else
    {
	    this._gc_geometry = undefined;
	    this._feature.setGeometry(undefined);
    }


    return this;
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.getGeometry = function ()
{
    return this._gc_geometry;
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.getAttribute = function (name)
{
    return this._feature.get(name);
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.setAttribute = function (name, value)
{
    this._feature.set(name, value);
    return this;
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.unsetAttribute = function (name)
{
	this._feature.unset(name);
	return this;
};

/**
 * @inheritDoc
 */
gc.gis.feature.OLFeature.prototype.clone = function ()
{
	return new gc.gis.feature.OLFeature(this._feature.clone());
};